import React, { useState } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Media from './media';
// import checkBg from '../../../assets/check.gif';

const rightIcon = 'https://x0.ifengimg.com/ucms/2022_06/9085C3BB1451AA14851C0DD9782C297C70AB507E_size8_w90_h90.png';
const errorIcon = 'https://x0.ifengimg.com/ucms/2022_06/C4613D81A9088B33FCC1695261DFEEB2CAF3A6E2_size16_w90_h90.png';

const Content = ({ data, index, total, changeIndex, changeScore }) => {
    const { img_url, video_url, title, options, correct_answer, weights } = data;
    const [checked, setChecked] = useState('');
    const [isRight, setIsRight] = useState(true);

    const handleOptionClick = answer => {
        if (checked) {
            return;
        }

        setChecked(answer);
        if (answer === correct_answer) {
            changeScore(weights);
            setIsRight(true);
        } else {
            setIsRight(false);
        }
        setTimeout(() => {
            changeIndex(index + 1);
        }, 1400);
    };

    const mediaConfig = {
        img_url,
        video_url,
    };

    return (
        <div className={styles.wrap}>
            <Media mediaConfig={mediaConfig} />
            <div className={styles.card}>
                <div className={styles.cardTitle} />
                <div className={styles.question}>
                    {index + 1}/{total}. {title}
                </div>
                <div className={styles.answer}>
                    {options.map(item => {
                        const { index: optionIndex, option } = item;

                        return (
                            <div
                                className={styles.option}
                                key={optionIndex}
                                onClick={() => {
                                    handleOptionClick(optionIndex);
                                }}>
                                {checked === optionIndex ? (
                                    <div className={styles.checkBg}>
                                        <img src={isRight ? rightIcon : errorIcon} />
                                        {/* <img src={`${checkBg}?${new Date().getTime()}`} alt="" /> */}
                                    </div>
                                ) : null}
                                {optionIndex}、{option}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

Content.propTypes = {
    data: PropTypes.object,
    index: PropTypes.number,
    total: PropTypes.number,
    changeIndex: PropTypes.func,
    changeScore: PropTypes.func,
};

export default errorBoundary(Content);
